import React from "react";
import { Link } from "react-router-dom";

export default function TermsOfUse() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-[#FF9A5A] to-[#FF5F52] text-white antialiased font-sans scroll-smooth">
      {/* ================= HEADER ================= */}
      <header className="max-w-6xl mx-auto px-6 py-8 flex items-center justify-between">
        <div className="font-bold text-lg">BiteMark</div>
      </header>

      {/* ================= MAIN ================= */}
      <main className="max-w-4xl mx-auto px-6 py-16">
        <h1 className="text-4xl font-bold mb-6">Terms of Use</h1>

        <p className="text-white/80 mb-4">
          By using the BiteMark app, you agree to these Terms of Use. 
          Please read them carefully. If you do not agree, you may not use the app.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">1. App Usage</h2>
        <p className="text-white/80 mb-4">
          BiteMark is designed to help users save, organize, and explore food locations from videos. 
          The app is intended for lawful, personal, and recreational use only.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">2. Account Responsibility</h2>
        <p className="text-white/80 mb-4">
          Users are responsible for maintaining the confidentiality of their account credentials 
          and for any activity occurring under their account. Share your account only with trusted individuals.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">3. Restrictions</h2>
        <p className="text-white/80 mb-4">
          Users may not use BiteMark to:
          <ul className="list-disc list-inside mt-2">
            <li>Track or collect personal information of others.</li>
            <li>Engage in any illegal activity.</li>
            <li>Attempt to modify, hack, or redistribute the app without permission.</li>
          </ul>
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">4. Device Permissions</h2>
        <p className="text-white/80 mb-4">
          Certain BiteMark features, like saving your location for map pins, may request access to your device location. 
          These permissions are <strong>only</strong> used to enable the feature and are never used for tracking or advertising.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">5. Intellectual Property</h2>
        <p className="text-white/80 mb-4">
          All content, branding, and design within BiteMark are the property of BiteMark. 
          Users may not reproduce, distribute, or create derivative works without express written consent.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">6. No Warranty</h2>
        <p className="text-white/80 mb-4">
          BiteMark is provided "as is" without warranty of any kind. We do not guarantee uninterrupted service, 
          accuracy of features, or suitability for any particular purpose. Users use the app at their own risk.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">7. Limitation of Liability</h2>
        <p className="text-white/80 mb-4">
          BiteMark is not liable for any damages, including loss of data or issues with device functionality. 
          Users remain responsible for supervising account usage, particularly for minors.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">8. Updates and Changes</h2>
        <p className="text-white/80 mb-4">
          We may update the app or these Terms of Use periodically. Continued use of BiteMark constitutes acceptance of the updated terms. 
          The latest version will always be available in the app and on our website.
        </p>

        <h2 className="text-2xl font-semibold mt-8 mb-4">9. Contact Us</h2>
        <p className="text-white/80 mb-4">
          For questions about these Terms of Use, contact us at{" "}
          <a
            href="mailto:thebitemarkapp@gmail.com"
            className="underline hover:text-[#FFD369]"
          >
            thebitemarkapp@gmail.com
          </a>.
        </p>
      </main>

      {/* ================= FOOTER ================= */}
      <footer className="border-t border-white/10 py-8 mt-20">
        <div className="max-w-6xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-4 text-white/60">
          <div className="text-sm">© {new Date().getFullYear()} BiteMark — All rights reserved.</div>
          <div className="flex items-center gap-4">
            <Link to="/" className="text-sm hover:text-white transition">Back to Home</Link>
            <Link to="/privacy-policy" className="text-sm hover:text-white transition">Privacy Policy</Link>
            <a href="mailto:thebitemarkapp@gmail.com" className="text-sm hover:text-white transition">thebitemarkapp@gmail.com</a>
          </div>
        </div>
      </footer>

      <style>{`html { scroll-behavior: smooth; }`}</style>
    </div>
  );
}
